import { API, graphqlOperation } from "aws-amplify";
import { createInvoice_Items, deleteInvoice_Items, updateInvoice_Items } from "../../graphql/mutations";
import { getInvoice_Items, listInvoice_Itemss } from "../../graphql/queries";

export const CreateNewInvoice = async (postParams) => {
  try {
    const result = await API.graphql(
      graphqlOperation(createInvoice_Items, postParams)
    );
    return result.data.createInvoice_Items;
  } catch (res) {
    const { errors } = res;
    console.error(errors);
  }
};

export const GetInovices = async () => {
  try {
    const result = await API.graphql(graphqlOperation(listInvoice_Itemss));
    const data = result.data.listInvoice_Itemss;
    return data;
  } catch (res) {
    const { errors } = res;
    console.error(errors);
  }
};

export const GetInoviceById = async (id) => {
  try {
    const result = await API.graphql(graphqlOperation(getInvoice_Items, { invoice_items_id: id }));
    const data = result.data.getInvoice_Items;
    return data;
  } catch (res) {
    const { errors } = res;
    console.error(errors);
  }
};

export const DeleteInvoice = async (params) => {
  try {
    const result = await API.graphql(graphqlOperation(deleteInvoice_Items, params));
    return result;
  } catch (res) {
    const { errors } = res;
    console.error(errors);
  }
};

export const UpdateInvoice = async (postParams) => {
  try {
    const result = await API.graphql(graphqlOperation(updateInvoice_Items, postParams));
    return result;
  } catch (res) {
    const { errors } = res;
    console.error(errors);
  }
};